// extracted by mini-css-extract-plugin
module.exports = {"header":"unknown-user-modal_header__JL5_c","description":"unknown-user-modal_description__3nKRT","text":"unknown-user-modal_text__3W5pK"};